export const NEWS_CONST = {
    GET_NEWS: "GET_NEWS",
    GET_NEWS_BLOCK: "GET_NEWS_BLOCK",
}